import { t } from 'i18next';

import { ErrorResponseErrorItemCodeGeodata } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeGeodata, string> => ({
  'geodata:not_found': t('geodata.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen kunde inte hittas.',
  }),
  'geodata:user_unauthorized': t('geodata.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till molnprocesseringen.',
  }),
  'geodata:not_ready_for_gcp': t('geodata.notReadyForGcp', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen är inte i rätt läge för GCP-justering.',
  }),
  'geodata:not_idle': t('geodata.notIdle', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Molnprocesseringen pågår. Vänta till molnprocesseringen är klar och försök sedan igen.',
  }),
  'geodata:coordinate_system_not_found': t('geodata.coordinateSystemNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen saknar koordinatsystem.',
  }),
  'geodata:filtered_point_cloud_not_found': t('geodata.filteredPointCloudNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det filtrerade punktmolnet kunde inte hittas.',
  }),
  'geodata:tiled_model_not_found': t('geodata.tiledModelNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Cesium 3D-modellen kunde inte hittas.',
  }),
  'geodata:has_volume_calculations': t('geodata.hasVolumeCalculations', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Det finns volymberäkningar kopplade till molnprocesseringens punktmoln. Ta bort dessa och försök igen.',
  }),
  'geodata:connected_to_timeline': t('geodata.connectedToTimeline', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Molnprocesseringen är kopplad till minst en tidslinje. Koppla bort molnprocesseringens avbildning, ortofoto samt punktmoln från berörda tidslinjer och försök sedan igen.',
  }),
  'geodata:has_skyview_artifacts': t('geodata.hasSkyviewArtifacts', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen är kopplad till SkyView-data. Ta bort den och försök igen.',
  }),
  'geodata:has_terrain_model': t('geodata.hasTerrainModel', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen är kopplad till en markmodell. Ta bort den och försök igen.',
  }),
  'geodata:has_filtered_point_cloud': t('geodata.hasFilteredPointCloud', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Molnprocesseringen är kopplad till ett utglesat punktmoln. Ta bort det och försök igen.',
  }),
  'geodata:point_cloud_not_found': t('geodata.pointCloudNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen har inget punktmoln.',
  }),
  'geodata:filtered_point_cloud_addon_not_found': t('geodata.filteredPointCloudAddonNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen saknar tillägget utglesat punktmoln.',
  }),
  'geodata:invalid_job_options': t('geodata.invalidJobOptions', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen har ogiltiga inställningar och kan därför inte startas.',
  }),
  'geodata:no_access_to_pipeline': t('geodata.noAccessToPipeline', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar åtkomst till det valda molnprocesseringsjobbet.',
  }),
  'geodata:conflicting_marker': t('geodata.conflictingMarker', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det går inte att skapa flaggan för det finns redan en annan flagga.',
  }),
  'geodata:gcp_not_found': t('geodata.gcpNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'GCP saknas.',
  }),
  'geodata:image_not_found': t('geodata.imageNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Bild saknas.',
  }),
  'geodata:boundary_polygon_not_found': t('geodata.boundaryPolygonNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Gränspolygon saknas.',
  }),
  'geodata:not_supported_process_type': t('geodata.notSupportedProcessType', {
    ns: 'apiErrorCodes',
    defaultValue: 'Molnprocesseringen har ogiltigt val av process-typ och kan därför inte startas.',
  }),
  'geodata:marker_not_found': t('geodata.markerNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Flaggan saknas.',
  }),
});
